import React, {Fragment} from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    GridList,
    DialogActions,
    Button,
    Slide,
    useTheme,
    GridListTile, Grid
} from "@material-ui/core";
import Rest from "../../../../helpers/Rest";
import useStyles from "./styles"

const Transition = React.forwardRef(
    (props, ref) => (
            <Slide direction="up" ref={ref} {...props} />
        )
)

class Credentials extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            loading: false
        }
    }

    close(){
        this.setState({open: false})
    }

    cell(heading, content, rows){
        return (
            <GridListTile rows={rows}>
                <Grid container spacing={1}>
                    <Grid item xs={12} className={this.props.classes.heading}>
                        {heading}
                    </Grid>
                    <Grid item xs={12} className={this.props.classes.value}>
                        <pre>
                            {content}
                        </pre>
                    </Grid>
                </Grid>
            </GridListTile>
        )
    }

    getDetails(){
        this.setState({loading: true})
        Rest.get(`device/${this.props.deviceId}/credentials`).then(reply => {
            this.setState({
                loading: false,
                open: true,
                details: reply
            })
        }).catch(e => {
            this.setState({loading: false})
            throw e
        })
    }

    open(){
        if (this.state.details){
            this.setState({open: true})
        }
        else{
            this.getDetails()
        }
    }

    button(){
        return (<Button
            variant="text"
            color="primary"
            onClick={this.open.bind(this)}
        >
            Get SSH Credentials
        </Button>)
    }

    dialog(details){
        const close = this.close.bind(this)
        return (
            <Dialog
                open={this.state.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={close}
                aria-labelledby="cred-title"
            >
                <DialogTitle id="cred-title">SSH Credentials for {this.props.deviceName}</DialogTitle>
                <DialogContent>
                    <GridList cellHeight={64} cols={1}>
                        {this.cell("Username", details.username, 1)}
                        {this.cell("Reverse Proxy Port", details.reverse_proxy_port, 1)}
                        {this.cell("API Token", details.api_token, 1)}
                        {this.cell("API Key", details.api_key, 1)}
                        {this.cell("Public SSH Key", details.public_ssh_key, 2)}
                        {this.cell("Private SSH Key", details.private_ssh_key, 14)}
                    </GridList>
                </DialogContent>
                <DialogActions>
                    <Button onClick={close}>Close</Button>
                </DialogActions>
            </Dialog>
        )
    }

    render(){
        const details = this.state.details
        if (!details){
            return this.button()
        }
        return <Fragment>
            {this.button()}
            {this.dialog(details)}
        </Fragment>
    }
}

export default function(props){
    const classes = useStyles(useTheme())
    return <Credentials classes={classes} {...props}/>
}
